import React from "react";

const Standard = ({ contrast, logoDark, logo, l10n, include }) => {
  return (
    <div className="callFullscreen">
      <header className="inCallHeader branding-header">
        <img
          className="logo"
          src={contrast ? logoDark : logo}
          alt={l10n("menu.logo")}
        />
      </header>
      <div className="box callContainer">
        <main className="row content margin-0_1em call-center">{include}</main>
      </div>
    </div>
  );
};

export default Standard;






// WEBPACK FOOTER //
// ./src/kiosk/Standard.jsx